import moment from 'moment'
import numbro from 'numbro'
import { coinFormats } from './constants'

export const getTimeToTarget = target => {
  const durationToTarget = moment.duration(target.diff(moment()))

  const days = Math.floor(durationToTarget.asDays())
  const hours = Math.floor(durationToTarget.subtract(days, 'days').asHours())
  const minutes = Math.floor(
    durationToTarget.subtract(hours, 'hours').asMinutes()
  )
  const seconds = Math.floor(
    durationToTarget.subtract(minutes, 'minutes').asSeconds()
  )

  return { days, hours, minutes, seconds }
}

export const formatUSD = amount => {
  const amountAsNumber = Number(amount || 0)
  return numbro(amountAsNumber).format('$0,0.00')
}

export const formatPips = amount => {
  const amountAsNumber = Number(amount || 0)
  return numbro(amountAsNumber).format('$0,0.0000')
}

export const formatCoin = (amount, currency) => {
  let amountAsNumber = Number(amount || 0)
  return (
    numbro(amountAsNumber).format(
      coinFormats[currency] || coinFormats.default
    ) +
    ' ' +
    currency
  )
}

export const formatBigNumber = amount => {
  const amountAsNumber = Number(amount || 0)
  return numbro(amountAsNumber).format('0,0')
}

export const formatDateTime = datetime =>
  moment(datetime).format('MM/DD/YYYY [at] h:mm A')

export const getTransactionURL = transaction => {
  if (transaction.currency === 'ETH') {
    return `${process.env.REACT_APP_ETHERSCAN_URL}/tx/${transaction.key}`
  } else {
    const transactionId = transaction.key.substr(
      0,
      transaction.key.lastIndexOf('@')
    )
    return `${process.env.REACT_APP_BLOCKCYPHER_URL}/tx/${transactionId}`
  }
}

export const getPurchaseURL = purchaseId => `/purchase/${purchaseId}`

export const dataToArray = (data = {}) => {
  return Object.keys(data).map(key => ({ ...data[key], key }))
}

export const copyToClipboard = (event, ref) => {
  if (event) event.target.select()
  if (ref) ref.select()
  document.execCommand('copy')
}

export const hasEarlyAccess = profile => {
  return (
    dataToArray(profile.types || [])
      .map(t => t.key)
      .indexOf('early-access-type') !== -1 ||
    dataToArray(profile.types || [])
      .map(t => t.key)
      .indexOf('-L398IvorXUS5_raHBd8') !== -1 ||
    dataToArray(profile.types || [])
      .map(t => t.key)
      .indexOf('-L4E2GOKSVS_b_Jmt8BX') !== -1 ||
    dataToArray(profile.types || [])
      .map(t => t.key)
      .indexOf('-L3rttj55bKZ7WOQaM4b') !== -1
  )
}

export const purchaseStatus = purchase => {
  // if (purchase.completedPayments) {
  //   return 'completed'
  // } else {
  return (purchase.status || '').replace(/([A-Z])/g, ' $1')
  // }
}

export const sleep = ms => {
  return new Promise(res => setTimeout(res, ms))
}



// WEBPACK FOOTER //
// ./src/helpers.js